import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import get from 'lodash.get';

interface TicketCapSummaryProps {
  /** Total tickets already sold across all ticket types (from the campaign read model). */
  soldCount?: number | null;
}

const formatCount = (value: number) =>
  value.toLocaleString(undefined, { maximumFractionDigits: 0 });

/**
 * Read-only context shown under the ticket cap input on the edit ticketing tab.
 * Surfaces how many tickets have already been sold so the admin understands that
 * setting the cap below this number would stop new sales. Reads from the loaded
 * campaign record (not the form model), so it is not sent in the save payload.
 */
export const TicketCapSummary: React.FC<TicketCapSummaryProps> = ({ soldCount }) => {
  if (!soldCount || soldCount <= 0) {
    return null;
  }

  return (
    <div className="ticket-cap-summary" style={{ marginTop: '-8px', marginBottom: '16px' }}>
      <span style={{ marginRight: '6px' }}>
        {I18n.t('template.page.content.ticketing.ticket-cap.summary.sold', {
          count: formatCount(soldCount)
        })}
      </span>
      <span style={{ color: 'var(--text-secondary, #666)' }}>
        {I18n.t('template.page.content.ticketing.ticket-cap.summary.below-warning')}
      </span>
    </div>
  );
};

const mapState = (state: any): TicketCapSummaryProps => ({
  // Use ticketing.ticketCap.sold (the count measured against the cap) so this
  // matches the "sold" figure shown in the performance ticketing widget.
  soldCount: get(state, 'campaign.record.data.data.ticketing.ticketCap.sold', null)
});

export default connect(mapState)(TicketCapSummary);
